/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import Translation from 'generics/Translation'
import { Col, Row } from 'reactstrap'
import { Card, Main } from 'generics/Card'
import classNames from 'classnames'
import { I18N } from 'constants/props'
import StyledButton from 'generics/StyledFormComponents/StyledButton/StyledButton'
import { Link, withRouter } from 'react-router-dom'

import { formatRoute } from 'react-router-named-routes'
import { ADMINISTRATION } from 'constants/urls'
import PropTypes from 'prop-types'

import styles from './MyTeamLimitedMembers.scss'

const { PUBLIC_PATH } = process.env

const TEAM_DYNAMICS_IMAGE = `${window.location.origin}${PUBLIC_PATH}/teams/team-dynamics.png`
const SPIDER_GRAPH_IMAGE = `${window.location.origin}${PUBLIC_PATH}/teams/spider-graph.png`
const TEAM_ENERGY_IMAGE = `${window.location.origin}${PUBLIC_PATH}/teams/team-energy.png`

const LEADERSHIP_REPORTS_ICON = `${window.location.origin}${PUBLIC_PATH}/teams/leadership-reports.svg`
const LEADERSHIP_GUIDES_ICON = `${window.location.origin}${PUBLIC_PATH}/teams/leadership-guides.svg`
const DYNAMICS_GIDE_ICON = `${window.location.origin}${PUBLIC_PATH}/teams/dynamics-guide.svg`

/**
 * My Teams Component for Limited Members
 * @extends Component
 */

const MyTeamLimitedMembers = ({ accountId, i18n }) => {
  const iconList = [
    {
      id: 'leadershipReports',
      icon: LEADERSHIP_REPORTS_ICON,
      title: i18n.pageTeams.limitedMember.sectionOne.leadershipReports.title,
      description: i18n.pageTeams.limitedMember.sectionOne.leadershipReports.description,
    },
    {
      id: 'leadershipGuides',
      icon: LEADERSHIP_GUIDES_ICON,
      title: i18n.pageTeams.limitedMember.sectionOne.leadershipGuides.title,
      description: i18n.pageTeams.limitedMember.sectionOne.leadershipGuides.description,
    },
    {
      id: 'dynamicsGuide',
      icon: DYNAMICS_GIDE_ICON,
      title: i18n.pageTeams.limitedMember.sectionOne.dynamicsGuide.title,
      description: i18n.pageTeams.limitedMember.sectionOne.dynamicsGuide.description,
    },
  ]

  return (
    <div>
      <Card
        barClassName={styles.bar}
        className={classNames(styles.card, styles.sectionOne)}
        data-test-component="my-network-limited-members"
      >
        <Main>
          <Row>
            <Col xs="12" md="12" className={classNames(styles.top)}>
              <h1 className={`${styles.title} ${styles.padding12}`}>{i18n.pageTeams.limitedMember.sectionOne.title}</h1>
              <div className={`epic ${styles.padding12}`}>
                <p className={styles.description}>{i18n.pageTeams.limitedMember.sectionOne.description}</p>
              </div>
              <div className={styles.buttonWrap}>
                <Link
                  href={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                  title={i18n.pageTeams.limitedMember.upgrageToPro}
                  to={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                >
                  <StyledButton
                    color="primary"
                    title={i18n.pageTeams.limitedMember.upgrageToPro}
                    className={classNames(styles.button)}
                  >
                    {i18n.pageTeams.limitedMember.upgrageToPro}
                  </StyledButton>
                </Link>
              </div>
            </Col>
          </Row>
          <Row>
            {iconList.map(item => (
              <Col xs="12" md="12" lg="4" className={classNames(styles.col_first)}>
                <div key={item.id} className={styles.iconContainer}>
                  <div className={styles.icon}>
                    <img alt={item.title} src={item.icon} />
                  </div>
                  <div className={classNames('epic')}>
                    <h3 className={styles.title}>{item.title}</h3>
                    <p className={styles.iconDescription}>{item.description}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Main>
      </Card>
      <Card
        barClassName={styles.bar}
        className={classNames(styles.card, styles.sectionTwo)}
        data-test-component="my-network-limited-members"
      >
        <Main>
          <Row>
            <Col xs="12" md="12" className={classNames(styles.top)}>
              <h2 className={`${styles.title2} ${styles.padding12}`}>
                {i18n.pageTeams.limitedMember.sectionTwo.title}
              </h2>
              <div className={`${styles.epic} ${styles.padding12}`}>
                <p className={styles.description}>{i18n.pageTeams.limitedMember.sectionTwo.description}</p>
              </div>
              <div className={styles.buttonWrap}>
                <Link
                  href={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                  title={i18n.pageTeams.limitedMember.upgrageToPro}
                  to={formatRoute(ADMINISTRATION, { accountId, sectionId: 'people' })}
                >
                  <StyledButton
                    color="primary"
                    title={i18n.pageTeams.limitedMember.upgrageToPro}
                    className={classNames(styles.button)}
                  >
                    {i18n.pageTeams.limitedMember.upgrageToPro}
                  </StyledButton>
                </Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="4" lg="4" className={classNames(styles.col_second)}>
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.pageTeams.limitedMember.sectionTwo.title}
                  className={classNames(styles.image)}
                  src={TEAM_DYNAMICS_IMAGE}
                />
              </div>
              <h2 className={styles.title}>{i18n.pageTeams.limitedMember.sectionTwo.teamDynamics}</h2>
            </Col>
            <Col xs="12" md="4" lg="4" className={classNames(styles.col_second)}>
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.pageTeams.limitedMember.sectionTwo.title}
                  className={classNames(styles.image)}
                  src={SPIDER_GRAPH_IMAGE}
                />
              </div>
              <h2 className={styles.title}>{i18n.pageTeams.limitedMember.sectionTwo.spiderGraph}</h2>
            </Col>
            <Col xs="12" md="4" lg="4" className={classNames(styles.col_second)}>
              <div className={classNames(styles.imageContainer)}>
                <img
                  alt={i18n.pageTeams.limitedMember.sectionTwo.title}
                  className={classNames(styles.image)}
                  src={TEAM_ENERGY_IMAGE}
                />
              </div>
              <h2 className={styles.title}>{i18n.pageTeams.limitedMember.sectionTwo.teamEnergy}</h2>
            </Col>
          </Row>
        </Main>
      </Card>
    </div>
  )
}

MyTeamLimitedMembers.propTypes = {
  accountId: PropTypes.number.isRequired,
  i18n: I18N.isRequired,
}

export default withRouter(Translation(MyTeamLimitedMembers, ['pageTeams']))
